module.exports = {
    getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
        var R = 6371; // Radius of the earth in km
        var dLat = this.deg2rad(lat2-lat1);  // deg2rad below
        var dLon = this.deg2rad(lon2-lon1);
        var a =
            Math.sin(dLat/2) * Math.sin(dLat/2) +
            Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
            Math.sin(dLon/2) * Math.sin(dLon/2)
            ;
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
        var d = R * c; // Distance in km
        return d;
    },
    deg2rad(deg) {
        return deg * (Math.PI/180);
    },
    calculateDistance(coordinates) {
        var dist = 0;
        for (var i = 0; i < coordinates.length-1; i++) {
            dist += this.getDistanceFromLatLonInKm(coordinates[i][1],coordinates[i][0],coordinates[i+1][1],coordinates[i+1][0]);
        }
        return dist;
    },
    today() {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();
        today = yyyy + '/' + mm + '/' + dd;
        return today;
    }
}


// WEBPACK FOOTER //
// ./resources/js/helpers.js